import { getFromLocalStorage } from "@app/dashboard/utils/manageLocalStorage";
import { LOCAL_STORAGE_KEYS } from "@app/dashboard/constants/local-storage-keys";
import { axiosPublic } from "@app/dashboard/tools/axios/axiosInstance";

export const changePassword = (oldPassword: string, newPassword: string) => {
  const tempToken = getFromLocalStorage(LOCAL_STORAGE_KEYS.TEMP_TOKEN);
  const headers = { "Authorization": `Bearer ${tempToken}` };

  const reqBody = {
    "old_password": oldPassword,
    "new_password": newPassword,
    "auth_token": tempToken,
  };

  return axiosPublic.post(`/api/auth/change_pass`, reqBody, { headers: headers });

};